import Borders from "../../../style/Borders";
import Background from "../../../style/Background";
import { EditableProps } from "../../../editableProps";
import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import Typography from "@builder/components/editable/style/Typography";

const EditPaymentGridButton = ({ parent, path, title, excluded }: EditableProps) => {
    return (
        <SidebarCollapse title={title ? title : "Button styling"} parent={parent}>
            <Background noWrapper path={path} />
            {!excluded?.includes("typography") && <Typography noWrapper path={path} customLabel="Typography color" excluded={excluded} />}{" "}
            <Borders noWrapper path={path} />
        </SidebarCollapse>
    );
};

export default EditPaymentGridButton;
